const INITIAL_STATE = {
  orderChoosed: null,
  orders: [],
  branchChanged: false,
  orderEdited: false,
  supplyBranches: [],
  deletedItem: false,
  date: "",
  requisitionEdit: false,
  editMobile: false
};

export default function orderEditReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case "SET_ORDER_EDIT":
      return {
        ...state,
        orderChoosed: action.orderChoosed
      };
    case "SET_ORDERS_EDIT":
      return {
        ...state,
        orders: action.orders
      };
    case "CHANGE_BRANCH":
      return {
        ...state,
        branchChanged: !state.branchChanged
      };
    case "ADD_SUPPLYBRANCH":
      return {
        ...state,
        supplyBranches: action.supplyBranches
      };
    case "EDIT_ITEM":
      return {
        ...state,
        ...(state.orders[action.index] = action.item),
      };
    case "DELETE_ITEM":
      return {
        ...state,
        orders: state.orders.filter((item) => item.code !== action.item.code),
      };
    case "DELETED_ITEM":
      return {
        ...state,
        deletedItem: !state.deletedItem
     };
    case "ORDER_EDITED_DONE":
      return {
        ...state,
        orderEdited: !state.orderEdited
      };
    case "ORDER_EDIT_DONE": 
      return {
        orderChoosed: null,
        orders: [],
        branchChanged: false,
        orderEdited: false,
        supplyBranches: [],
        deletedItem: false,
        date: "",
        requisitionEdit: false
      };
    case "ADD_DATE_EDIT":
      return { 
        ...state, 
        date: action.date 
      };
    case "SET_REQUISITION_EDIT": 
      return {
        ...state,
        requisitionEdit: action.requisitionEdit
      }
    case "SET_EDIT_MOBILE": 
      return {
        ...state,
        editMobile: action.editMobile
      }
    default:
      return state;
  }
}
